import { EMPTY_OBJECT } from '../../../../constants/common'
import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../../../utils/massActions'
import {
  REQUEST_PROFILE_TAB_EMAILS_FOLDER_ARCHIVED,
  REQUEST_PROFILE_TAB_EMAILS_FOLDER_IMPORTANT,
  REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION,
  REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION,
  REQUEST_PROFILE_TAB_EMAILS_STATE_KEYS,
} from '../RequestProfileTabEmails.constants'

export function getRequestProfileTabEmailsItemActions({ item, subMenu }) {
  const { permissions = EMPTY_OBJECT, starred, unread } = item

  const isArchived = subMenu === REQUEST_PROFILE_TAB_EMAILS_FOLDER_ARCHIVED

  const items = [
    {
      label: 'RequestProfile.TabEmailsOpenInNewTabActionKey',
      permission: true,
      value: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.OpenInNewTab,
    },
    {
      label: 'RequestProfile.TabEmailsMarkAsUnreadActionKey',
      permission: permissions.can_edit_unread_status && !unread,
      value: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsUnread,
    },
    {
      label: 'RequestProfile.TabEmailsMarkAsReadActionKey',
      permission: permissions.can_edit_unread_status && unread,
      value: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsRead,
    },
    {
      label: 'RequestProfile.TabEmailsMarkAsStarredActionKey',
      permission: !isArchived && permissions.can_edit_starred && !starred,
      value: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsStarred,
    },
    {
      label: 'RequestProfile.TabEmailsMarkAsUnstarredActionKey',
      permission: !isArchived && permissions.can_edit_starred && starred,
      value: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MarkAsUnstarred,
    },
    {
      label: 'RequestProfile.TabEmailsMoveToTabActionKey',
      permission: !isArchived && permissions.can_edit_audience,
      value: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MoveToTab,
    },
    {
      label: 'RequestProfile.TabEmailsMoveToServiceRequestActionKey',
      permission: !isArchived && permissions.can_move_to_another_request,
      value: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.MoveToAnotherServiceRequest,
    },
    {
      label: 'RequestProfile.TabEmailsAttachToActivityActionKey',
      permission: !isArchived && permissions.can_attach_to_activity,
      value: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.AttachToActivity,
    },
    {
      label: 'RequestProfile.TabEmailsAddNoteActionKey',
      permission: !isArchived && permissions.can_edit_note,
      value: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.AddNote,
    },
    {
      label: 'RequestProfile.TabEmailsPrintActionKey',
      permission: true,
      value: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.Print,
    },
    null,
    {
      label: 'RequestProfile.TabEmailsDeleteActionKey',
      permission: permissions.can_delete,
      value: REQUEST_PROFILE_TAB_EMAILS_ITEM_ACTION.Delete,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}

export function getRequestProfileTabEmailsMassActions({
  permissions = EMPTY_OBJECT,
  subMenu,
  t,
}) {
  const isArchived = subMenu === REQUEST_PROFILE_TAB_EMAILS_FOLDER_ARCHIVED
  const isImportant = subMenu === REQUEST_PROFILE_TAB_EMAILS_FOLDER_IMPORTANT

  const items = [
    {
      label: t('RequestProfile.TabEmailsMarkAsUnreadActionKey'),
      permission: permissions.can_edit_unread_status,
      value: REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsUnread,
    },
    {
      label: t('RequestProfile.TabEmailsMarkAsReadActionKey'),
      permission: permissions.can_edit_unread_status,
      value: REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsRead,
    },
    {
      label: t('RequestProfile.TabEmailsMarkAsStarredActionKey'),
      permission: !isArchived && !isImportant && permissions.can_edit_starred,
      value: REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsStarred,
    },
    {
      label: t('RequestProfile.TabEmailsMarkAsUnstarredActionKey'),
      permission: !isArchived && permissions.can_edit_starred,
      value: REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.MarkAsUnstarred,
    },
    null,
    {
      label: t('RequestProfile.TabEmailsDeleteActionKey'),
      permission: permissions.can_delete,
      value: REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.Delete,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}

export function getRequestProfileTabEmailsEmptyStateKey({
  hasError,
  isSearchResult,
}) {
  return hasError
    ? REQUEST_PROFILE_TAB_EMAILS_STATE_KEYS.ErrorStateKey
    : isSearchResult
      ? REQUEST_PROFILE_TAB_EMAILS_STATE_KEYS.SearchEmptyStateKey
      : REQUEST_PROFILE_TAB_EMAILS_STATE_KEYS.EmptyStateKey
}
